import { Component } from '@angular/core';

@Component({
  selector: 'public-site',
  template: `
    <main class="full-display bg-bhbody">
      <public-header-component></public-header-component>
      <router-outlet></router-outlet>
    </main>
    <footer-component></footer-component>
  `,
  styles: []
})
export class PublicSiteComponent {

  constructor() { }

}
